import informations from "@/api/informations";

export default {
    state: {
    },

    mutations: {
    },

    actions: {
        async retrieveInformations(context, { count, lastId = null, skip = 0 }) {
            try {
                let params = {
                    management_id: await context.dispatch("showManagementID"),
                    count: count,
                };
                if (lastId) {
                    params.latest_information_id = lastId;
                }
                if (skip > 0) {
                    params.skip_page = skip;
                }
                let res = await informations.index(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async retrieveAllInformations(context) {
            try {
                let params = {
                    management_id: await context.dispatch("showManagementID"),
                };
                let res = await informations.index(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
        async insertInformations(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                await informations.insert(params);
            } catch (error) {
                console.log(error);
            }
        },
        async updateInformations(context, params) {
            try {
                params.account_id = await context.dispatch("showAccountID");
                params.management_id = await context.dispatch("showManagementID");
                await informations.update(params);
            } catch (error) {
                console.log(error);
            }
        },
        async updateReadInformation(context, { user_id, information_id }) {
            try {
                const params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    user_id: user_id,
                    information_id: information_id,
                };
                await informations.updateRead(params);
            } catch (error) {
                console.log(error);
            }
        },
        async deleteInformations(context, id) {
            try {
                let params = {
                    account_id: await context.dispatch("showAccountID"),
                    management_id: await context.dispatch("showManagementID"),
                    information_id: id,
                }
                await informations.del(params);
            } catch (error) {
                console.log(error);
            }
        }
    },

    getters: {
    },
};
